import Vue from 'vue';
import Configurator from './Components/Configurator.vue';

export default class App {
  constructor() {
    /* eslint-disable no-new */
    if (document.querySelector('#app')) {
      new Vue({
        el: '#app',
        components: { Configurator },
      });
    }
  }
}

